
import { useState } from 'react';

export default function ServicesSection() {
  const [activeService, setActiveService] = useState(0);
  
  const services = [
    {
      title: 'Business Strategy',
      content: 'Market analysis, roadmap development, and strategic planning to position your business for success.'
    },
    {
      title: 'Financial Advisory',
      content: 'Budgeting, risk management, growth funding strategies, and financial optimization solutions.'
    },
    {
      title: 'Change Management',
      content: 'Smooth transitions for teams and processes, ensuring minimal disruption and maximum adoption.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-900 mb-4">
            Our Services
          </h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-6">
            {services.map((service, index) => (
              <div key={index} className="border-b border-gray-200 pb-6">
                <button
                  onClick={() => setActiveService(activeService === index ? -1 : index)}
                  className="w-full text-left flex items-center justify-between cursor-pointer"
                >
                  <h3 className="text-xl font-medium text-gray-900">
                    {service.title}
                  </h3>
                  <i className={`ri-${activeService === index ? 'subtract' : 'add'}-line text-gray-600`}></i>
                </button>
                
                {activeService === index && (
                  <div className="mt-4">
                    <p className="text-gray-600 font-light leading-relaxed">
                      {service.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/fc2a218bfe41d2fda6cb49749b031dd1.jpg"
              alt="Team collaboration"
              className="w-full h-80 object-cover object-top rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
